<template>
  <section>
    <el-button style="margin-bottom: 10px" type="primary" @click="dialogVisible = true">新增</el-button>
    <el-table
      border
      :max-height="tableHeight"
      :data="tabel_list"
      header-cell-class-name="header_cell_name"
      :cell-style="{ 'text-align': 'center' }"
      highlight-current-row
      :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA', padding: ' 7px 0 !important' }"
      style="width: 100%"
    >
      <el-table-column type="index"></el-table-column>
      <el-table-column prop="periods" label="手术量可填写月份"></el-table-column>
      <el-table-column prop="createdTime" label="创建时间"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 1" type="success">启用中</el-tag>
          <el-tag v-else type="danger">已停用</el-tag>
        </template>
      </el-table-column>
      <!-- 发送邮件功能暂未实现，先隐藏 -->
      <!-- <el-table-column label="操作">
        <template scope="scope">
          <el-link v-if="scope.row.status === 1" type="primary" @click="sendEmail(scope.row)">
            <i class="el-icon-s-promotion"></i>
            发送通知邮件
          </el-link>
          <el-link v-else type="info">
            <i class="el-icon-s-promotion"></i>
            发送通知邮件
          </el-link>
        </template>
      </el-table-column> -->
    </el-table>
    <el-dialog title="历史手术量可填写月份" :visible.sync="dialogVisible" width="350px">
      <el-cascader
        collapse-tags
        :options="options"
        v-model="tag_list"
        :props="props"
        @change="xzchange"
        placeholder="请选择月份"
        clearable
        style="width: 100%; margin-right: 10px"
      ></el-cascader>
      <br />
      <div style="text-align: center"><el-button type="primary" style="margin-top: 30px" @click="submit">保存</el-button></div>
    </el-dialog>
  </section>
</template>

<script>
import util from '../../../util/date'
import { cataractnnvmplistmonthconfigs, cataractnnvmp_createmonthconfig } from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Toolbar from '../../components/Toolbar'

export default {
  components: { Toolbar, quillEditor },
  data() {
    return {
      dialogVisible: false,
      tabel_list: [],
      tag_list: [],
      tag_list_string: [],
      props: { multiple: true },
      tableHeight: 0,
      options: [
        {
          value: '2025',
          label: '2025',
          children: [
            {
              value: '01',
              label: '1月',
            },
            {
              value: '02',
              label: '2月',
            },
            {
              value: '03',
              label: '3月',
            },
          ],
        },
        {
          value: '2026',
          label: '2026',
          children: [
            {
              value: '01',
              label: '1月',
            },
            {
              value: '02',
              label: '2月',
            },
          ],
        },
      ],
    }
  },
  methods: {
    sendEmail() {
      this.$confirm('是否发送邮件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {})
    },
    async submit() {
      // 允许创建空配置，用于停用历史月份填写功能
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
      })
      const { data } = await cataractnnvmp_createmonthconfig(this.tag_list_string)
      if (data.code === 200) {
        this.$message({
          message: data.msg,
          type: 'success',
        })
        this.getModules()
        this.dialogVisible = false
      } else {
        this.$message({
          message: data.msg,
          type: 'error',
        })
      }
      this.tag_list = []
      this.tag_list_string = []
      loading.close()
    },
    xzchange(e) {
      var arr = []
      e.filter((item) => {
        console.log(item)
        arr.push(item[0] + '-' + item[1])
      })
      this.tag_list_string = arr
    },
    async getModules() {
      const { data } = await cataractnnvmplistmonthconfigs()
      this.tabel_list = data.data
    },
    month_cad_list() {
      var arr = []
      for (let i = 2025; i < 2035; i++) {
        var obj = {}
        obj.value = i
        obj.label = i
        obj.children = []
        for (let j = 1; j < 13; j++) {
          var obj1 = {}
          obj1.value = j < 10 ? '0' + j : j
          obj1.label = j < 10 ? '0' + j : j
          obj.children.push(obj1)
        }
        arr.push(obj)
      }
      this.options = arr
      console.log(arr)
    },
  },
  async mounted() {
    this.getModules()
    this.month_cad_list()
    this.isMobile = window.innerWidth <= 767
    this.$nextTick(() => {
      this.$nextTick(() => {
        if (this.isMobile) {
          this.tableHeight = window.innerHeight - 190
        } else {
          this.tableHeight = window.innerHeight - 250
        }
      })
    })
  },
}
</script>

<style scoped></style>
